import { validationMessage } from 'vuelidate-messages'
import { required, email, sameAs } from 'vuelidate/lib/validators'
import { messages } from '@lib/validation-helpers'

export const validations = {
  validations() {
    const validations = {
      email: { required, email }
    }

    if (this.token) {
      validations.pass = {
        required
      }
      validations.passConfirm = {
        sameAs: sameAs('pass')
      }
    }

    return validations
  },

  methods: {
    $v_displayMessage: validationMessage(messages),
    $v_validationPass() {
      this.$v.$touch()
      return !this.$v.$invalid
    }
  }
}
